import React from 'react'
import { Navigate, useRoutes } from 'react-router-dom'
import { useUser } from '../hooks/useUser'
import { generateRoutes } from '../router/helpers'
import { useScrollToTop } from '../hooks/useScrollToTop'

export function Home() {
  useScrollToTop();
  const { role, user, subscription } = useUser()
  // `useRoutes` runs UNCONDITIONALLY, above the redirect below. It used to sit
  // after that early return, so any in-session flip of role/user (a logout, a
  // profile refetch that momentarily clears it) changed the hook count between
  // renders and threw "Rendered fewer hooks than expected" — which the root
  // errorElement then turned into a sticky /404.
  const elements = useRoutes(role && user ? generateRoutes(role, subscription) : [])
  // The app's socket connection is mounted by DownloadsProvider (index.tsx),
  // above the router, so it also covers the public share pages.
  if (!role || !user) {
    // Capture the current page the user was trying to access
    const currentPath = window.location.pathname + window.location.search;
    
    // Encode the current path to safely include it as a query parameter
    const redirectParam = encodeURIComponent(currentPath);
    console.log("Redirecting to login with redirect param:", redirectParam);
    
    console.log("No role or user, redirecting to login");
    return <Navigate to={`/login?redirect=${redirectParam}`} />
  }

  return elements
}
